<template>
    <div>
      <el-card
        :class="getMainContainerStyles()"
        v-if="!data.additional_info.no_style"
      >
        <div class="wrapper">
          <div v-if="data.additional_info.prepend_img">
            <div v-if="!data.additional_info.prepend_tooltip">
              <img
                :src="selectedImages(data.additional_info.prepend_img)"
                alt=""
                class="iconsClass"
              />
            </div>
            <div v-else>
              <el-tooltip
                class="item"
                effect="dark"
                :content="data.additional_info.prepend_tooltip"
                placement="top-start"
              >
                <img
                  :src="selectedImages(data.additional_info.prepend_img)"
                  alt=""
                  style="cursor: pointer"
                  class="iconsClass"
                />
              </el-tooltip>
              <p class="labels hideForDS" style="margin-bottom: 6px">Pincode<span style="color: red">*</span></p>
            </div>
          </div>

          <div
            v-if="
              (data.question_type === 'short_answer' ||
                data.question_type === 'number') &&
              data.additional_info.is_images_required &&
              !data.additional_info.is_last_input
            "
            style="width: 100%"
            class="inputContainer"
          >
            <el-input
              id="inputRef"
              :class="getInputStyles()"
              :maxlength="6"
              pattern="\d*"
              :placeholder="data.description"
              v-model="data.additional_info.default_option"
              @focus="validateFocusedField(data.label)"
              @blur="validateData(data, data.label)"
              @input="
                handleInputValueChange(
                  data.additional_info.default_option,
                  data.label,
                  data
                )
              "
              type="number"
              :controls="false"
              @keydown="preventSpecialCharacters(data.label)"
            >
              <template
                #append
                v-if="
                  data.additional_info.append_img ||
                  data.additional_info.append_text
                "
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Click here to find my location"
                  placement="top-start"
                >
                  <img
                    v-if="data.additional_info.append_img"
                    @click="getUserLocation(data)"
                    :src="selectedImages(data.additional_info.append_img)"
                    alt="image"
                    style="cursor: pointer"
                    class="getLocationIcon"
                  />
                </el-tooltip>
                <span v-if="data.additional_info.append_text">{{
                  data.additional_info.append_text
                }}</span>
              </template>
            </el-input>
          </div>

          <div
            v-if="data.additional_info.is_last_input"
            class="lastInputContainer"
          >
            <p class="labels">
              {{ data.label }}
            </p>

            <div
              v-if="
                data.additional_info.additional_question == 'multiple_choice'
              "
              :class="!calculatorData.isTata ? 'multipleInputs2 removeMarginForSD' : 'multipleInputs'"
              style="width: 100%"
            >
              <el-radio-group
                :model-value="data.additional_info.additional_default_option"
                @change="handleUnitChange"
              >
                <el-radio
                  v-for="option in data.additional_info.additional_options"
                  :key="option.label"
                  :label="option.label"
                >{{ option.label }}</el-radio>
              </el-radio-group>
            </div>

            <div class="inputContainer" style="margin-left: auto; display: flex; align-items: center">
              <el-input
                :placeholder="data.description"
                v-model="data.additional_info.default_option"
                @blur="validateData(data, data.label)"
                @focus="validateFocusedField(data.label)"
                type="number"
                :controls="false"
                @input="
                  handleInputValueChange(
                    data.additional_info.default_option,
                    data.label,
                    data
                  )
                "
                class="no-arrow-buttons"
                :disabled="handleAdditionalQuestions(data.additional_info, data.label)"
                @keydown="preventSpecialCharacters(data.label)"
              >
                <template
                  #append
                  v-if="data.additional_info.append_text !== ''"
                >
                  <p class="unit_text">{{ data.additional_info.append_text }}</p>
                </template>
              </el-input>
            </div>
          </div>

          <div
            v-if="!data.additional_info.is_images_required"
            style="margin-top: 3px"
          >
            <p class="labels">{{ data.label }}</p>
          </div>

          <div
            v-if="data.question_type === 'multiple_choice'"
            style="margin-left: auto; margin-top: 5px"
            :class="['powerSupplyRadioBtns',!calculatorData.isTata ? 'multipleInputs2' : 'multipleInputs']"
          >
            <el-radio-group
              v-model="data.additional_info.default_option"
              @change="
                handleInputValueChange(
                  data.additional_info.default_option,
                  data.label
                )
              "
            >
              <el-radio
                :label="options.option_text"
                v-for="options in data.options"
                :disabled="options.tab_disable"
                >{{ options.option_text }}</el-radio
              >
            </el-radio-group>
          </div>
        </div>
      </el-card>

      <div
        v-if="data.additional_info.no_style && data.question_type !== 'slider'"
        :class="!calculatorData.isTata ? 'multipleInputs2' : 'multipleInputs'"
      >
        <p style="color: black">{{ data.label }}</p>
        <el-radio-group
          v-model="data.additional_info.default_option"
          @change="
            handleInputValueChange(
              data.additional_info.default_option,
              data.label
            )
          "
        >
          <el-radio v-for="items in data.options" :label="items.option_text">{{
            items.option_text
          }}</el-radio>
        </el-radio-group>
      </div>

      <div
        class="slider_container"
        v-if="data.additional_info.no_style && data.question_type === 'slider'"
      >
        <div :class="!calculatorData.isTata ? 'slider_option2 slider_option' : 'slider_option'">
          <div style="width: 100px">
            <p class="labels">{{ data.label }}</p>
          </div>
          <div class="sliderCont">
          <p style="white-space: nowrap">{{ !calculatorData.isTata ? 1 : 4 }}</p>
          <el-slider
            v-model="sliderValue"
            @input="handleSliderChange()"
            :min="!calculatorData.isTata ? 1 : 4"
            :max="!calculatorData.isTata ? 18 : 30"
            class="custom-slider"
          >
          </el-slider>
          <p style="width: 12%; white-space: nowrap">{{ !calculatorData.isTata ? 18 : 30 }}</p>
          </div>
          <div class="number_input">
            <img
              :src="handleSliderDecreaseButtons('decrease')"
              @click="handleTariffValueChange('decrease')"
              :class="handleSliderInnerButtons('decrease')"
            />
            <div class="time_input_container">
              <input
                type="number"
                v-model="inputValue"
                class="time_input"
                @input="handleTariffChange()"
                :controls="false"
                @keydown="preventSpecialCharacters(data.label)"
              />
              <p style="margin-left: auto" class="unit_text">INR</p>
            </div>
            <img
              :src="handleSliderButtons('increase')"
              @click="handleTariffValueChange('increase')"
              :class="handleSliderInnerButtons('increase')"
            />
          </div>
        </div>
      </div>

      <div
        v-if="
          data.label === 'Available Roof Top Area' && errorForm.rooftop_error
        "
        class="warning"
        style="margin-bottom: 10px"
      >
        Your Rooftop area is insufficient to support solar plant
      </div>

      <div
        v-if="
          data.label === 'Available Roof Top Area' && errorForm.max_area_error
        "
        class="info_description"
        style="margin-bottom: 10px"
      >
        Maximum rooftop area limit is 9999999.
      </div>

      <div
        v-if="data.label === 'Pincode' && errorForm.pincode_error === true"
        class="warning"
      >
        Please enter a valid pin code
      </div>

      <div v-if="showSectionLoadNote" class="info_description" style="margin-top: 6px">
        Add monthly electricity bill.
      </div>

      <div
        v-if="
          data.label === 'Sanction Load' && errorForm.sanction_error === true && !calculatorData.isTata && (calculatorData.sanction_load > (calculatorData.monthly_bill/100))
        "
        class="warning"
      >
        Sanctioned load is too high. Maximum allowed: {{ (calculatorData.monthly_bill/100).toFixed(0) }} kW.
      </div>

      <div
        v-if="
          data.label === 'Sanction Load' && errorForm.sanction_error === true && calculatorData.isTata
        "
        class="warning"
      >
        Should be between 1 and 100
      </div>
      <div
        v-if="data.label === 'Tariff Rates' && errorForm.tariff_error"
        class="warning"
      >
        Should be between {{ !calculatorData.isTata ? 1 : 4 }} and {{ !calculatorData.isTata ? 18 : 30 }}
      </div>

      <div
        v-if="data.label === 'Sanction Load' && errorForm.change_phase_error"
        class="info_description" style="margin-top: 6px"
      >
        Note: Your Phase has been changed to {{ phase }}.
      </div>

      <div
        v-if="data.label === 'Monthly Electricity Bill' && errorForm.bill_error"
        class="warning"
      >
        Should be greater than or equal to 1000
      </div>

      <div
        v-if="
          data.label === 'Monthly Electricity Bill' && errorForm.max_bill_error
        "
        class="info_description"
      >
        Maximum Electricity bill limit is 9999999.
      </div>

      <div v-if="data.additional_info.note">
        <p class="note">{{ data.additional_info.note }}</p>
      </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { solarCalculatorStore } from "../../../../store/solarCalculator";
import { GOOGLE_API_KEY } from "../../../../../services/api";
import location from "../../../assets/location.svg";
import location2 from "../../../assets/location2.svg";
import pinLocation from "../../../assets/pinLocation.svg";
import money from "../../../assets/money.svg";
import money2 from "../../../assets/money2.svg";
import sanctionload from "../../../assets/sanctionload.svg";
import sanctionload2 from "../../../assets/sanctionload2.svg";
import rooftop from "../../../assets/rooftop.svg";
import rooftop2 from "../../../assets/rooftop2.svg";
import battery from "../../../assets/battery.svg";
import areaRequired from "../../../assets/areaRequired.svg";
import addButton from "../../../assets/addButton.svg";
import addDisabled from "../../../assets/add_disable.svg";
import subsButton from "../../../assets/substract.svg";
import subsDisabled from "../../../assets/substract_disabled.svg";
import axios from "axios";

let isFetchingUserLocation = ref(false);
const props = defineProps({
  data: Object,
  errorForm: Object,
});

// Handle unit change for rooftop area
const handleUnitChange = (newUnit) => {
  if (props.data?.label !== 'Available Roof Top Area') return;
  
  const currentUnit = props.data.additional_info.additional_default_option;
  const currentValue = props.data.additional_info.default_option;
  
  // Always update the unit in the UI
  props.data.additional_info.additional_default_option = newUnit;
  
  // If no value or not a valid number, just update the unit
  if (!currentValue || isNaN(parseFloat(currentValue))) {
    store.UPDATE_CALCULATOR_DATA(newUnit, 'Rooftop Area Unit');
    return;
  }
  
  // Only convert if the unit is actually changing
  if (newUnit !== currentUnit) {
    let convertedValue;
    if (newUnit === 'Sq.m' && currentUnit === 'Sq.ft') {
      // Convert from sq.ft to sq.m: divide by 10.764
      convertedValue = (parseFloat(currentValue) / 10.764).toFixed(2);
    } else if (newUnit === 'Sq.ft' && currentUnit === 'Sq.m') {
      // Convert from sq.m to sq.ft: multiply by 10.764
      convertedValue = (parseFloat(currentValue) * 10.764).toFixed(2);
    }
    
    if (convertedValue) {
      // Update the store with the new unit and value
      store.UPDATE_CALCULATOR_DATA(newUnit, 'Rooftop Area Unit');
      store.UPDATE_CALCULATOR_DATA(convertedValue, 'Rooftop Area');
      
      // Update the local value
      props.data.additional_info.default_option = convertedValue;
    }
  }
};

const store = solarCalculatorStore();
const calculatorData = store.CALCULATOR_DATA_STATE;

const batteryImg = ref(battery);
const areaImg = ref(areaRequired);
const locationImg = ref(location);
const locationImg2 = ref(location2);
const pinLocationImg = ref(pinLocation);
const sanctionLoadImg = ref(sanctionload);
const sanctionLoadImg2 = ref(sanctionload2);
const moneyImage = ref(money);
const moneyImage2 = ref(money2);
const rooftopImage = ref(rooftop);
const rooftopImage2 = ref(rooftop2);
const add = ref(addButton);
const subs = ref(subsButton);
const addDisabledImg = ref(addDisabled);
const subsDisabledImg = ref(subsDisabled);
const sliderValue = ref(7);
const inputValue = ref(7);
const pin_error = ref(false);
const phase = ref("");
const showSectionLoadNote = ref(false);

watch(() => calculatorData.tariff_rate, (newVal) => {
  if (newVal !== undefined) {
    sliderValue.value = newVal;
    inputValue.value = newVal;
  }
}, { immediate: true });



const emits = defineEmits(["changeData", "changeError", "restrictPincode"]);

const validateFocusedField = (item) => {
  // Don't clear error when focusing on Sanction Load input
  if (item === 'Sanction Load') {
    return;
  }
  
  let label = "";
  if (item == "Available Roof Top Area") {
    label = "Rooftop Area";
  } else {
    label = item;
  }
  emits("changeError", label, false);
};

//onMount call getUserLocation()

const validateData = (data, item) => {
  switch (item) {
    case "Pincode":
      if (data.additional_info.default_option.length < 6) {
        emits("changeError", item, true);
      } else if (
        data.additional_info.default_option.length === 6 &&
        calculatorData.pin_code_error === true
      ) {
        emits("changeError", item, true);
      } else {
        emits("changeError", item, false);
      }

      break;
    case "Monthly Electricity Bill":
      if (
        parseInt(data.additional_info.default_option) <= 9999999 &&
        parseInt(data.additional_info.default_option) >= 0
      ) {
        data.additional_info.default_option = parseInt(
          data.additional_info.default_option
        );
      }
      if (parseInt(data.additional_info.default_option) >= 1000) {
        if (parseInt(data.additional_info.default_option) > 9999999) {
          data.additional_info.default_option = 9999999;
          emits("changeError", "Max Bill", true);

          setTimeout(() => {
            emits("changeError", "Max Bill", false);
          }, 3000);
        }
        emits("changeError", item, false);
      } else {
        emits("changeError", item, true);
      }

      break;

    case "Available Roof Top Area":
      let minValue;
      let maxValue;
      
      if (data.additional_info.additional_default_option === "Sq.ft") {
        minValue = 120;
        maxValue = 9999999;
      } else if (data.additional_info.additional_default_option === "Sq.m") {
        minValue = 11.15;
        maxValue = 929030.3;
      }
      const currentValue = parseFloat(data.additional_info.default_option) || 0;
      if (currentValue <= maxValue && currentValue >= 0) {
        if (currentValue > maxValue) {
          data.additional_info.default_option = maxValue;
        } else if (currentValue < minValue) {
          data.additional_info.default_option = minValue;
        } else {
          data.additional_info.default_option = currentValue;
        }
        
        store.UPDATE_CALCULATOR_DATA(data.additional_info.default_option, "Rooftop Area");
        emits("changeError", "Rooftop Area", false);
      } else {
        emits("changeError", "Rooftop Area", true);
      }
    
      break;

    case "Sanction Load":
      // Handle empty or invalid input
      if (data.additional_info.default_option === '' || data.additional_info.default_option === null || data.additional_info.default_option === undefined) {
        store.UPDATE_CALCULATOR_DATA('', item);
        emits('changeError', item, true);
        return;
      }
      
      // Convert to number and validate
      const numericValue = parseInt(data.additional_info.default_option);
      
      // If not a number, set error and empty value
      if (isNaN(numericValue)) {
        data.additional_info.default_option = '';
        store.UPDATE_CALCULATOR_DATA('', item);
        emits('changeError', item, true);
        return;
      }
      
      // For Tata users: 1-100 range
      if (calculatorData.isTata) {
        if (numericValue <= 0 || numericValue >= 101) {
          emits('changeError', item, true);
        } else {
          emits('changeError', item, false);
        }
      } 
      // For non-Tata users: Only check if value is positive and <= monthly_bill/100
      else {
        if (calculatorData.monthly_bill > 0) {
          const maxAllowed = Math.floor(calculatorData.monthly_bill / 100).toFixed(0);
          if (numericValue <= 0 || numericValue > maxAllowed) {
            emits('changeError', item, true);
          } else {
            emits('changeError', item, false);
          }
        } else if (numericValue <= 0) {
          emits('changeError', item, true);
        } else {
          emits('changeError', item, false);
        }
      }
      
      // Update store with the numeric value
      store.UPDATE_CALCULATOR_DATA(numericValue, item);
      break;

    default:
      break;
  }
};

const handleAdditionalQuestions = (data, label) => {
  // Disable Sanction Load if Monthly Electricity Bill is less than 1000
  if (!calculatorData.isTata && label === 'Sanction Load' && calculatorData.monthly_bill < 1000) {
    showSectionLoadNote.value = true;
    return true;
  } else {
    showSectionLoadNote.value = false;
  }
  
  // Original logic for other fields
  if (data.additional_question == "multiple_choice") {
    return !data.additional_default_option;
  }
  
  return false;
};

const preventSpecialCharacters = (label) => {
  const e = event;
  
  // Common allowed keys for all inputs
  const commonAllowedKeys = [
    'Backspace', 'Tab', 'Escape', 'Enter',
    'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
    'ArrowUp', 'ArrowDown' // Add arrow up/down keys
  ];
  
  // Allow: Common keys, Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
  if (
    commonAllowedKeys.includes(e.key) ||
    (e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key)
  ) {
    return; // Let it happen, don't do anything
  }
  
  // Allow decimal point only for 'Available Roof Top Area'
  if (e.key === '.') {
    if (label !== 'Available Roof Top Area') {
      e.preventDefault();
    }
    return;
  }
  
  // Block minus sign to prevent negative numbers
  if (e.key === '-') {
    e.preventDefault();
    return;
  }
  
  // Block any non-numeric characters
  if (isNaN(Number(e.key))) {
    e.preventDefault();
  }
};

const selectedImages = (data) => {
  switch (data) {
    case "batteryImg":
      return batteryImg.value;
      break;
    case "locationImg":
      if (!calculatorData.isTata) {
        return locationImg2.value;
      } else {
        return locationImg.value;
      }
      break;
    case "pinLocationImg":
      return pinLocationImg.value;
      break;
    case "sanctionLoadImg":
      if (!calculatorData.isTata) {
        return sanctionLoadImg2.value;
      } else {
        return sanctionLoadImg.value;
      }
      break;
    case "moneyImage":
      if (!calculatorData.isTata) {
        return moneyImage2.value;
      } else {
        return moneyImage.value;
      }
      break;
    case "rooftopImage":
      if (!calculatorData.isTata) {
        return rooftopImage2.value;
      } else {
        return rooftopImage.value;
      }
      break;
    case "areaImg":
      return areaImg.value;
      break;
    default:
      return null;
      break;
  }
};

// Get min and max values based on isTata
const getTariffRange = () => {
  return {
    min: calculatorData.isTata ? 4 : 1,
    max: calculatorData.isTata ? 30 : 18
  };
};

const handleSliderButtons = (trigger) => {
  const { max } = getTariffRange();
  if (trigger === "increase" && sliderValue.value >= max) {
    return addDisabledImg.value;
  } else {
    return add.value;
  }
};

const handleSliderDecreaseButtons = (trigger) => {
  const { min } = getTariffRange();
  if (trigger === "decrease" && sliderValue.value <= min) {
    return subsDisabledImg.value;
  } else {
    return subs.value;
  }
};

const handleSliderInnerButtons = (trigger) => {
  const { min, max } = getTariffRange();
  if (trigger === "decrease" && sliderValue.value <= min) {
    return "slider_inner_disable_button";
  }

  if (trigger === "increase" && sliderValue.value >= max) {
    return "slider_inner_disable_button";
  }

  return "slider_inner_button";
};

const handleTariffChange = () => {
  const { min, max } = getTariffRange();
  const inputVal = inputValue.value;
  
  // Handle empty input (when backspacing to empty)
  if (inputVal === '') {
    inputValue.value = min;
    sliderValue.value = min;
    handleInputValueChange(min, "Tariff Rates");
    emits("changeError", "Tariff Rates", false);
    return;
  }
  
  // Parse the value
  let value = parseFloat(inputVal);
  
  // If not a valid number, reset to min without showing error
  if (isNaN(value)) {
    inputValue.value = min;
    sliderValue.value = min;
    handleInputValueChange(min, "Tariff Rates");
    emits("changeError", "Tariff Rates", false);
    return;
  }
  
  // Round to nearest integer
  value = Math.round(value);
  
  // Clamp the value between min and max
  if (value < min) {
    value = min;
    emits("changeError", "Tariff Rates", false); // Don't show error for min value
  } else if (value > max) {
    value = max;
    emits("changeError", "Tariff Rates", false);
  } else {
    emits("changeError", "Tariff Rates", false);
  }
  
  // Update values if they've changed
  if (inputValue.value !== value.toString()) {
    inputValue.value = value;
  }
  if (sliderValue.value !== value) {
    sliderValue.value = value;
  }
  
  handleInputValueChange(value, "Tariff Rates");
};

const handleTariffValueChange = (trigger) => {
  const { min, max } = getTariffRange();
  let newValue = sliderValue.value;
  
  if (trigger === "decrease" && sliderValue.value > min) {
    newValue = sliderValue.value - 1;
  } else if (trigger === "increase" && sliderValue.value < max) {
    newValue = sliderValue.value + 1;
  } else {
    // If we're at min/max and trying to go beyond, don't change anything
    return;
  }
  
  // Update values
  sliderValue.value = newValue;
  inputValue.value = newValue;
  
  // Only show error if value is below minimum
  const showError = newValue < min;
  emits("changeError", "Tariff Rates", showError);
  
  handleInputValueChange(newValue, "Tariff Rates");
};

const handleSliderChange = () => {
  const { min, max } = getTariffRange();
  
  // Ensure slider value is within bounds
  if (sliderValue.value < min) {
    sliderValue.value = min;
  } else if (sliderValue.value > max) {
    sliderValue.value = max;
  }
  
  inputValue.value = sliderValue.value;
  
  // Only show error if value is below minimum
  const showError = sliderValue.value < min;
  emits("changeError", "Tariff Rates", showError);
  
  handleInputValueChange(sliderValue.value, "Tariff Rates");
};

const getUserLocation = (data) => {
  isFetchingUserLocation.value = true;

  const successCallback = async (position) => {
    const long = position.coords.longitude;
    const lat = position.coords.latitude;
    store.UPDATE_CALCULATOR_DATA(lat, "Latitude");
    store.UPDATE_CALCULATOR_DATA(long, "Longitude");

    let response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${GOOGLE_API_KEY}`
    );

    // const results = response.data.results[0];
    // let addressComponent = results?.address_components?.filter((el) => {
    //   return el.types[0] === "postal_code";
    // });

    let address_pin_code = 0;

    response.data.results.map((address) => {
      address.address_components.map((data) => {
        if (data.types[0] === "postal_code") {
          address_pin_code = data.long_name;
          store.UPDATE_CALCULATOR_DATA(address_pin_code, "Pincode");
        }
      });
    });

    isFetchingUserLocation.value = false;
    const pin = address_pin_code;

    data.additional_info.default_option = pin;
    store.UPDATE_CALCULATOR_DATA(pin, "Pincode");
    emits("changeError", "Pincode", false);
    store.UPDATE_CALCULATOR_DATA(false, "pin_code_error");
  };

  const errorCallback = () => {
    store.UPDATE_CALCULATOR_DATA(true, "pin_code_error");
    ElMessage({
      showClose: true,
      message: "Enable your location to get pin",
      type: "error",
      center: true,
    });
    isFetchingUserLocation.value = false;
  };
  navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
};

const getCoordinatesFromPincode = async (pincode) => {
  const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${pincode}&key=${GOOGLE_API_KEY}`;

  try {
    const response = await fetch(apiUrl);
    const data = await response.json();

    if (data.results.length > 0) {
      const location = data.results[0].geometry.location;
      const latitude = location.lat;
      const longitude = location.lng;
      store.UPDATE_CALCULATOR_DATA(latitude, "Latitude");
      store.UPDATE_CALCULATOR_DATA(longitude, "Longitude");

      emits("changeError", "Pincode", false);
      store.UPDATE_CALCULATOR_DATA(false, "pin_code_error");
    } else {
      store.UPDATE_CALCULATOR_DATA(true, "pin_code_error");
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

const handleInputValueChange = (value, item, data) => {
  // Handle empty or invalid input
  if (value === '' || isNaN(parseFloat(value))) {
    // For rooftop area and sanction load, update store with empty value and set error
    if (item === 'Available Roof Top Area') {
      store.UPDATE_CALCULATOR_DATA('', 'Rooftop Area');
      emits('changeError', 'Rooftop Area', true);
    }
    
    if (item === 'Sanction Load') {
      store.UPDATE_CALCULATOR_DATA('', 'Sanction Load');
      emits('changeError', 'Sanction Load', true);
    }

    if (item === 'Power Supply Phase') {
       store.UPDATE_CALCULATOR_DATA(value, 'Power Supply Phase');
    }
    return;
  }
  
  // Parse the value and ensure it's not negative
  let newValue = parseFloat(value);
  if (newValue < 0) {
    newValue = 0;
    data.additional_info.default_option = newValue;
  }
  switch (item) {
    case "Pincode":
      if (data.additional_info.default_option.length > 6) {
        data.additional_info.default_option =
          data.additional_info.default_option.slice(0, 6);
      }
      if (value.length === 6) {
        store.UPDATE_CALCULATOR_DATA(value, item);
        getCoordinatesFromPincode(value);
      }

      break;
    case "Category":
      store.UPDATE_CALCULATOR_DATA(value, item);

      break;
    case "Sanction Load":
      // Convert to number and validate
      const numericValue = parseInt(value);
      
      // Update store with the numeric value if valid, otherwise empty string
      store.UPDATE_CALCULATOR_DATA(isNaN(numericValue) ? '' : numericValue, item);

      // For Tata users: 1-100 range
      if (calculatorData.isTata) {
        if (isNaN(numericValue) || numericValue <= 0 || numericValue >= 101) {
          emits("changeError", item, true);
        } else {
          emits("changeError", item, false);
        }
      } 
      // For non-Tata users: Check if value is positive and within monthly bill limit
      else {
        if (isNaN(numericValue) || numericValue <= 0) {
          emits("changeError", item, true);
        } else if (calculatorData.monthly_bill > 0) {
          const maxAllowed = Math.floor(calculatorData.monthly_bill / 100).toFixed(0);
          if (numericValue > maxAllowed) {
            emits("changeError", item, true);
          } else {
            emits("changeError", item, false);
          }
        } else {
          emits("changeError", item, false);
        }
      }

      if (newValue > 0 && newValue <= 100) {
        store.UPDATE_CALCULATOR_DATA(value, item);

        if (newValue > 3) {
          if (newValue === 4 || newValue === 5) {
            emits("changeData", "neutral", false);
          }
          if (!calculatorData.isTata ? newValue >= 5 : newValue >= 6) {
            phase.value = "three phase";
            if (calculatorData.supply_phase === "Three Phase") {
              emits("changeData", "Three Phase", true);
              emits("changeError", "Power Supply Phase", false);
            } else {
              emits("changeData", "Three Phase", true);
              emits("changeError", "Power Supply Phase", true);
            }
            store.UPDATE_CALCULATOR_DATA("Three Phase", "Power Supply Phase");
            setTimeout(() => {
              emits("changeError", "Power Supply Phase", false);
            }, 10000);
          }
        }
        if (!calculatorData.isTata ? newValue < 4 : newValue <= 3) {
          phase.value = "single phase";
          if (calculatorData.supply_phase === "Single Phase") {
            emits("changeData", "Single Phase", true);
            emits("changeError", "Power Supply Phase", false);
          } else {
            emits("changeData", "Single Phase", true);
            emits("changeError", "Power Supply Phase", true);
          }
          store.UPDATE_CALCULATOR_DATA("Single Phase", "Power Supply Phase");
          setTimeout(() => {
            emits("changeError", "Power Supply Phase", false);
          }, 10000);
        }
      }

      break;
    case "Monthly Electricity Bill":
      if(value  < 1000) {
        emits("changeError", item, true);
      } else {
        emits("changeError", item, false);
      }
      store.UPDATE_CALCULATOR_DATA(value, "Electricity Bill");
      if (data.additional_info.default_option.length > 7) {
        data.additional_info.default_option =
          data.additional_info.default_option.slice(0, 7);
        store.UPDATE_CALCULATOR_DATA(
          data.additional_info.default_option,
          "Electricity Bill"
        );
      }

      break;
    case "Available Roof Top Area":


    if(calculatorData.rooftop_area_unit === "Sq.ft") {
      if(value > 120) {
        emits("changeError", "Rooftop Area", false);
      } else {
        emits("changeError", "Rooftop Area", true);
      }
    } else if(calculatorData.rooftop_area_unit === "Sq.m") {
      if(value > 11.14) {
        emits("changeError", "Rooftop Area", false);
      } else {
        emits("changeError", "Rooftop Area", true);
      }
    }
      
      // Handle input length limit first
      if (value !== undefined && value !== null) {
        const stringValue = value.toString();
        if (stringValue.length > 7) {
          const limitedValue = stringValue.slice(0, 7);
          data.additional_info.default_option = limitedValue;
          store.UPDATE_CALCULATOR_DATA(limitedValue, "Rooftop Area");
        } else {
          // Only update the store if the value is different to prevent unnecessary updates
          if (data.additional_info.default_option !== value) {
            store.UPDATE_CALCULATOR_DATA(value, "Rooftop Area");
          }
        }
      }

      break;
    case "Tariff Rates":
      const { min, max } = getTariffRange();
      // Ensure value is within allowed range
      if (newValue < min) {
        newValue = min;
      } else if (newValue > max) {
        newValue = max;
      }
      // Update the input and slider values
      if (data && data.additional_info) {
        data.additional_info.default_option = newValue;
      }
      store.UPDATE_CALCULATOR_DATA(newValue, item);
      // Update the slider value
      sliderValue.value = newValue;
      // Update error state - only show error if value is below minimum
      emits("changeError", "Tariff Rates", newValue < min);
      break;
    default:
      store.UPDATE_CALCULATOR_DATA(value, item);
      break;
  }
};

const errorMap = {
  Pincode: "pincode_error",
  "Sanction Load": "sanction_error",
  "Tariff Rates": "tariff_error",
  "Available Roof Top Area": "rooftop_error",
  "Monthly Electricity Bill": "bill_error",
};

const getMainContainerStyles = () => {
  const errorName = errorMap[props.data.label];

  if (errorName && props.errorForm[errorName] === true) {
    return "errorContainer";
  }
  return "mainContainer";
};

const getInputStyles = () => {
  const errorName = errorMap[props.data.label];

  if (errorName && props.errorForm[errorName] === true) {
    return "errorInput";
  }
  return "no-spinner";
};
</script>

<style scoped>
.mainContainer {
  padding: 6px 16px;
  border-radius: 8px;
  background: var(--White, #fff);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  /* height: 55px; */
}

.errorContainer {
  padding: 5px 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  background: var(--White, #fff);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  /* height: 50px; */
  margin-top: 8px;
  border: 1px solid red;
  color: red;
}

.labels {
  margin-left: 10px;
  margin-right: 8px;
  color: black;
  width: inherit;
}

.hideForDS {
  display: none;
}

.lastInput {
  /* width: 25px; */
  text-align: end;
  border: none;
  outline: none;
}

.no-arrow-buttons >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.time_input_container >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.no-arrow-buttons {
  width: 100%;
}

.errorInput >>> .el-input__inner {
  color: red;
}

.lastInputContainer {
  display: flex;
  align-items: center;
  width: 100%;
}

.lastInputContainer >>> .el-input-group__append {
  box-shadow: none;
  background-color: white;
  padding: 0;
}

.inputContainer >>> .el-input__inner {
  color: black;
  background-color: white !important;
}

.lastInputContainer >>> .el-input__inner {
  text-align: right;
  color: black;
  background-color: white !important;
  padding: 7px;
  min-width: 75px;
}

.lastInputContainer >>> .el-input__wrapper {
  border: none;
  box-shadow: none;
  background: none;
}

.unit_text {
  color: var(--Grey-777, var(--777, #777));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.custom-slider {
  width: 90%;
}

.el-popper-container-2058 >>> .el-popper {
  background-color: white;
  color: black;
}

.mainContainer >>> .el-card__body {
  padding: 0;
}

.errorContainer >>> .el-card__body {
  padding: 0;
}

.wrapper {
  display: flex;
  align-items: center;
}

.input {
  width: 100%;
}

.unitsContainer {
  margin-left: auto;
}

.info_description {
  color: var(--777, #777);
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.selectContainer {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.textContainer {
  display: flex;
  flex: 2;
}

.inputContainer >>> .el-input__wrapper {
  box-shadow: none;
}


.multipleInputs >>> .el-radio__input.is-checked + .el-radio__label,
.multipleInputs2 >>> .el-radio__input.is-checked + .el-radio__label {
  color: black;
}

.multipleInputs >>> .el-radio__input.is-checked .el-radio__inner,
.multipleInputs2 >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #006eaf;
  background-color: white;
  border: 2px solid #006eaf;
}

.multipleInputs2 >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #409EFF;
  border: 2px solid #409EFF;
}

.multipleInputs >>> .el-radio__inner::after,
.multipleInputs2 >>> .el-radio__inner::after {
  height: 7px;
  width: 7px;
  background-color: #006eaf;
  left: 50%;
  top: 50%;
}

.multipleInputs2 >>> .el-radio__inner::after {
  background-color: #409EFF;
}

.inputContainer >>> .el-input-group__append {
  box-shadow: none;
  background-color: white;
  padding: 0;
}

.lastInputContainer >>> .el-input-group__prepend {
  box-shadow: none;
  background-color: white;
  padding: 0;
}

.inputContainer >>> .el-input-group__prepend {
  box-shadow: none;
  background-color: white;
  padding: 0;
}
.note {
  color: var(--777, #777);
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 8px;
}

.errorInput >>> input[type="number"]::-webkit-inner-spin-button,
.errorInput input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  color: red;
}

.no-spinner >>> input[type="number"]::-webkit-inner-spin-button,
.no-spinner input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  color: red;
}

.slider_option >>> .el-input-number__decrease {
  border-radius: 25px;
  background-color: #0d0d0d;
  color: white;
  font-size: 10px;
  width: 20px;
  font-weight: 700;
  height: 20px;
  margin-left: 16px;
  margin-top: 5px;
}

.slider_option {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 8px;
}

.sliderCont {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}

.slider_option >>> .el-input-number__increase {
  border-radius: 25px;
  background-color: #0d0d0d;
  color: white;
  width: 20px;
  height: 20px;
  font-size: 10px;
  font-weight: 700;
  margin-top: 5px;
}

.slider_option :deep() .el-slider__bar {
  background-color: #006eaf;
}

.slider_option2 :deep() .el-slider__bar {
  background-color: #409EFF;
}

.slider_option >>> .el-input__inner {
  border: 1px solid var(--999, #999);
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color))
    inset;
  width: 60px;
  background: white;
  border-radius: 5px;
  margin-left: 1.5px;
}

.slider_option >>> .el-input__wrapper {
  box-shadow: none;
  background: #edf1f5;
}

.slider_option >>> .el-slider__button {
  border: 3px solid var(--White, #fff);
  background: var(--Primary, #006eaf);
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.5);
  height: 15px;
  width: 15px;
}

.slider_option2 >>> .el-slider__button {
  background: var(--Primary, #409EFF);
}

.number_input {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
}
.time_button {
  height: 22px;
  width: 22px;
  border-radius: 50%;
  border: none;
  color: white;
  background-color: #0d0d0d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.time_button_disabled {
  height: 22px;
  width: 22px;
  border-radius: 50%;
  border: none;
  color: white;
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  cursor: not-allowed;
}
.time_input_container {
  border-radius: 4px;
  border: 1px solid var(--999, #999);
  background: var(--White, #fff);
  width: 70px;
  padding: 5px;
  display: flex;
  align-items: center;
  position: relative;
}

.time_input {
  outline: none;
  border: none;
  width: 30px;
}

.slider_inner_button {
  cursor: pointer;
}

.slider_inner_disable_button {
  cursor: not-allowed;
}

.slider_container {
  padding: 5px 16px;
  border-radius: 8px;
  background: var(--White, #fff);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  height: 55px;
  margin-bottom: 6px;
}

.no-arrow-buttons >>> .is_focus {
  display: none;
}
.warning {
  color: red;

  font-size: 12px;
}

@media (max-width: 1368px) {
  .mainContainer {
    height: auto;
    padding: 6px 16px;
  }

  .media_label {
    width: 100%;
  }

  .slider_container {
    height: auto;
    padding: 6px 16px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
}

@media (max-width: 1180px) {
  .mainContainer {
    padding: 0;
    border-radius: 0;
    background: var(--White, #fff);
    box-shadow: none;
    border: none;
    height: auto;
  }

  .media_label {
    width: 87px;
  }
}

@media (max-width: 800px) {
  .mainContainer {
    height: auto;
  }

  .media_label {
    width: 100%;
  }

  .slider_container {
    height: auto;
    padding: 6px 16px;
    margin-top: 8px;
    margin-bottom: 8px;
    box-shadow: none;
  }
}

@media (max-width: 800px) {

  .wrapper {
    align-items: start;
    flex-direction: column;
  }

  .multipleInputs2,
  .multipleInputs {
    margin: 0 !important;
    margin-top: 8px !important;
  }

  .removeMarginForSD {
    margin-top: 0px !important;
  }

  .hideForDS {
    display: block;
  }

  .labels {
    margin: 0px;
    font-size: 14px;
    color: #777;
    font-weight: bold;
  }

  .slider_container {
    padding: 0;
    margin: 0;
  }

  .slider_option {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 0px;
  }

  .lastInputContainer {
    gap: 6px;
    flex-direction: column;
    align-items: flex-start;
  }

  .inputContainer {
    margin: 0 !important;
    width: 100%;
  }

  .errorContainer {
    padding: 0;
    margin-bottom: 6px;
    border-radius: 0;
    box-shadow: none;
    margin-top: 8px;
    border: none;
  }

  .inputContainer :deep() .el-input__inner{
    border: 1px solid #ccc;
    height: 48px;
    border-radius: 4px;
    padding: 8px 12px;
    text-align: left;
  }

  .inputContainer >>> .el-input__wrapper {
    padding: 0px;
  }

  .powerSupplyRadioBtns >>> .el-radio__label {
    font-size: 16px !important;
  }

  .iconsClass {
    display: none;
  }

  .time_input_container {
    width: 80px;
    height: 32px;
  }

  .time_input {
    width: 40px;
  }

  .unit_text,
  .getLocationIcon {
    position: absolute;
    top: 8;
    right: 12px;
  }
}
</style>
